export { ScreenService } from './services/screen.service';

export { MOBILE_MAX_WIDTH } from './constants/mobile-max-width.constant';
export { TABLET_MAX_WIDTH } from './constants/tablet-max-width.constant';
